export default "__VITE_ASSET__bcd10c2f__"